import { createRequestActionTypes } from '../../helpers'

export const FETCH_DEVICES = createRequestActionTypes('DEVICES', 'DEVICES')
